import http from "./httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/affiliates/";
const url = apiUrl + endPoint;

export async function getAffiliates(pageNumber, pageSize, searchQuery) {
  return await http.get(url + pageNumber + "/" + pageSize + "?searchQuery=" + searchQuery);
}

export async function getAffiliatesCount(searchQuery) {
    return await http.get(url + "count?searchQuery=" + searchQuery);
}

export async function getUserById(customerId) {
  return await http.get(url + customerId);
}

export async function addAffiliate(affiliate) {
  return await http.post(url, affiliate);
}

export async function updateUser(customerId, customer) {
  const payload = { ...customer };
  delete payload._id;
  delete payload.dob; //will be removed later
  return await http.put(url + customerId, payload);
}
